import * as React from 'react';
import assign = require('object-assign');
import translate from '../../../../locale/translate';

import Select, { Option } from 'rc-select';

import { Tag } from '../../../../store/models';

import { CustomerSelect } from '../../../reportSettings';
import { sortByKeyComparator } from '../../util/ArrayUtil';

import { IInputChangeEventHandler } from '../../../../interfaces';

interface ISettings {
    excludeTags: string[],
    includeTags: string[],
}

interface IProps {
    data: { tags: Tag[] },
    settings: ISettings,
    handleChange: IInputChangeEventHandler,
}

export { ISettings };

export default class NodeFilterEditor extends React.Component<IProps, void> {
    static propTypes = {
        data: React.PropTypes.object.isRequired,
        settings: React.PropTypes.object.isRequired,
        handleChange: React.PropTypes.func.isRequired,
    };

    filterOption(input: string, option) {
        const name = option.props.children.toLowerCase();
        return name.indexOf(input.toLowerCase()) >= 0;
    }

    renderTag(tag: Tag) {
        return (
            <Option key={tag.tId} value={tag.tId}>{tag.name}</Option>
        );
    }

    renderTagSelect(placeholder: string, key: string, value: string[], tags: Tag[], fireChange: IInputChangeEventHandler) {
        function handleChange(value) {
            fireChange(key, value);
        }

        return (
            <Select
                placeholder={placeholder}
                multiple
                style={{ width: '100%' }}
                dropdownMenuStyle={{ maxHeight: 200, overflow: 'auto' }}
                maxTagTextLenght={10}
                value={value}
                tokenSeparators={[' ', ',']}
                onChange={handleChange}
                optionFilterProp="children"
                optionLabelProp="children"
                filterOption={this.filterOption}
            >
                {tags.map(this.renderTag)}
            </Select>
        );
    }

    render() {
        const { handleChange, settings, data } = this.props;
        const tags = data.tags.sort(sortByKeyComparator('name', -1));

        return (
            <div>
                <div className="form-group">
                    {this.renderTagSelect(translate.gettext("With these tags"), "includeTags", settings.includeTags, tags, handleChange)}
                </div>
                <div className="form-group">
                    {this.renderTagSelect(translate.gettext("Without these tags"), "excludeTags", settings.excludeTags, tags, handleChange)}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/common/Editor/NodeTagFilterEditor.tsx